import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';
import { MatTableDataSource } from '@angular/material/table';
import { MessageDocument } from '../../../../models/net/envelope/documents/message-document';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { ChipSelectorComponent } from '../../../fragments/chip-selector/chip-selector.component';
import { AppService } from '../../../../services/app.service';
import { MessageService } from '../../../../services/messages/message.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MessageEnvelope } from '../../../../models/net/envelope/message-envelope';
import { Contact } from '../../../../models/data/app-core/contact';
import { MessageContact } from '../../../../models/data/messaging/message-contact';
import { UtilityFunctions } from '../../../../utilities/utility-functions';
import { EnvelopeFactory } from '../../../../utilities/envelope-factory';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css', '../../../../app.component.css']
})

export class MessageComponent extends EditorComponent {

    public availableContacts: AvatarPrimitive[] = [];
    public availableMessageFormats: any = null;
    public fromContactIds: number[] = [];
    public toContactIds: number[] = [];
    public ccContactIds: number[] = [];
    public bccContactIds: number[] = [];
    public selectedMessageFormat: any = {};
    public messageBody: string = "";
    public ccBccDivDynamicClassName: string = "expanding-div-collapsed";
    public ccBccToggleButtonDynamicIconName: string = "keyboard_double_arrow_down";

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    @ViewChild("fromChipSelector") fromChipSelector!: ChipSelectorComponent;
    @ViewChild("toChipSelector") toChipSelector!: ChipSelectorComponent;
    @ViewChild("ccChipSelector") ccChipSelector!: ChipSelectorComponent;
    @ViewChild("bccChipSelecto") bccChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: MessageService, 
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "message", "messages");
    }

    public override initializeEnvelope = (envelope: MessageEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new MessageEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        this.fromContactIds = [(this.itemEnvelope.Document as MessageDocument).Item.FromContactId];
        this.toContactIds = (this.itemEnvelope.Document as MessageDocument).Recipients.filter((i: MessageContact) => i.RecipientTypeId == 1).map((i: MessageContact) => i.ContactId);
        this.ccContactIds = (this.itemEnvelope.Document as MessageDocument).Recipients.filter((i: MessageContact) => i.RecipientTypeId == 2).map((i: MessageContact) => i.ContactId);
        this.bccContactIds = (this.itemEnvelope.Document as MessageDocument).Recipients.filter((i: MessageContact) => i.RecipientTypeId == 3).map((i: MessageContact) => i.ContactId);

        this.availableContacts = (this.itemEnvelope as MessageEnvelope).ContactsPool.map((i: Contact) => {
            let result = new AvatarPrimitive();
            result.Id = i.ContactId;
            result.Name = i.Name;
            result.AvatarBlobPath = i.AvatarBlobPath;
            return result;
        });

        this.availableMessageFormats = [
            { Id: 1, UID: "Text" },
            { Id: 2, UID: "HTML" }
        ];

        this.selectedMessageFormat = this.availableMessageFormats[0];

        if (this.itemEnvelope?.Document.Item.Body === null || this.itemEnvelope?.Document.Item.Body === undefined) {

            this.itemEnvelope!.Document.Item.Body = "";
        }
    }

    public ngAfterViewInit(): void {

        this.toChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.toContactIds.push(item.Id);
            this.addMessageContactToMessage(item.Id, 1);
        });

        this.toChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.toContactIds.splice(this.toContactIds.indexOf(item.Id), 1);
            this.removeMessageContactFromMessage(item.Id, 1);
        });

        this.ccChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.ccContactIds.push(item.Id);
            this.addMessageContactToMessage(item.Id, 2);
        });

        this.ccChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.ccContactIds.splice(this.ccContactIds.indexOf(item.Id), 2);
            this.removeMessageContactFromMessage(item.Id, 2);
        });

        this.bccChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.bccContactIds.push(item.Id);
            this.addMessageContactToMessage(item.Id, 3);
        });

        this.bccChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.bccContactIds.splice(this.toContactIds.indexOf(item.Id), 3);
            this.removeMessageContactFromMessage(item.Id, 3);
        });
    }

    public addMessageContactToMessage = (contactId: number, recipientTypeId: number): void => {

        const document: MessageDocument = (this.itemEnvelope?.Document as MessageDocument);
        const newMessageContact: MessageContact = new MessageContact();

        const newMessageContactProformaId: number = EnvelopeFactory.getProformaMessageContactId(document.Recipients);

        newMessageContact.MessageContactId = newMessageContactProformaId;
        newMessageContact.MessageId = document.Item.MessageId;
        newMessageContact.ContactId = contactId;
        newMessageContact.RecipientTypeId = recipientTypeId;

        document.Recipients.push(newMessageContact);
    }

    public removeMessageContactFromMessage(contactId: number, recipientTypeId: number): void {

        const document: MessageDocument = (this.itemEnvelope?.Document as MessageDocument);

        //const itemIndex: number | undefined = document.MessageContacts.map((i: MessageContact) => i.ContactId & i.RecipientTypeId == recipientTypeId).indexOf(contactId, 0);
        const itemIndex: number = document.Recipients.findIndex((i: MessageContact) => i.ContactId === contactId && i.RecipientTypeId === recipientTypeId);

        if (itemIndex != undefined && itemIndex > -1) {

            document.Recipients.splice(itemIndex, 1);
        }
    }

    public toggleCcBccFieldVisibility = (): void => {

        this.ccBccDivDynamicClassName = this.ccBccDivDynamicClassName == "expanding-div-collapsed" ? "expanding-div-expanded" : "expanding-div-collapsed";
        this.ccBccToggleButtonDynamicIconName = this.ccBccToggleButtonDynamicIconName == "keyboard_double_arrow_up" ? "keyboard_double_arrow_down" : "keyboard_double_arrow_up";
    }
}
